/** Source-neutral presentation of geopolitics already categorized in the
 * existing Telegram 10-minute macroMarketObservation pipeline.
 * This does not classify events, synthesize prices, or establish causation.
 */
export type GeoAsset = { name: string; returnPct: number };
export type GeoEvent = { headline: string; timeLabel: string; assets: GeoAsset[] };
type Obj = Record<string, unknown>;
const obj = (value: unknown): Obj => value && typeof value === 'object' && !Array.isArray(value)
  ? value as Obj : {};
const txt = (value: unknown): string => typeof value === 'string' ? value.trim() : '';
const rows = (value: unknown): unknown[] => Array.isArray(value) ? value : [];
function isGeopolitical(tag: string): boolean {
  return /^(?:GEOPOLITICAL(?:_RISK)?|GEO_RISK|GEOPOLITICS|WAR|CEASEFIRE|SANCTIONS?)$/i.test(tag);
}
export function geopoliticsForDisplay(macro: unknown): GeoEvent[] {
  const topics = rows(obj(macro).topics);
  const result: GeoEvent[] = [];
  const seen = new Set<string>();
  for (const value of topics) {
    const topic = obj(value);
    if (!isGeopolitical(txt(topic.topic))) continue;
    const headline = txt(topic.headline);
    if (!headline || seen.has(headline)) continue;
    seen.add(headline);
    const assets: GeoAsset[] = [];
    for (const valueAsset of rows(topic.assetObservations)) {
      const asset = obj(valueAsset);
      const pct = asset.observedChangePct;
      if (asset.status !== 'OBSERVED_PRICE_ONLY_NOT_CAUSAL'
        || typeof pct !== 'number' || !Number.isFinite(pct)
        || !txt(asset.beforeAt) || !txt(asset.afterAt)) continue;
      const name = txt(asset.assetKey);
      if (name) assets.push({name, returnPct: pct});
      if (assets.length >= 3) break;
    }
    const at = txt(topic.availableAt);
    const dt = at ? new Date(at) : null;
    const timeLabel = dt && Number.isFinite(dt.getTime()) ? new Intl.DateTimeFormat('ko-KR', {
      timeZone: 'Asia/Seoul', hour: '2-digit', minute: '2-digit', hour12: false,
    }).format(dt) : '';
    result.push({ headline, timeLabel, assets });
    if (result.length >= 2) break;
  }
  return result;
}
